import { useNavigate } from 'react-router-dom';
import * as React from "react";
import { ContactType } from "../../../profile/domain/contact-type";
import Header from "../../../../components/header/header";
import { BackBtn } from "../../../../components/header/btn/back-btn";
import { CompleteBtn } from "../../../../components/header/btn/complete-btn";
import { InputBox, InputBoxWithFixedText } from "../../../../components/inputbox";
import { ContactCard } from "./contact-card";
import { Switch } from "../../../../components/switch";
import Swal from "sweetalert2";
import { requestEditProfile, requestUploadProfileAndBackgroundImage } from "../../../../api/signcard";
import { useSetUserSession } from "../../../../state/user-session";

function ProfileEditPage({
    link,
    profileUpdater,
    contactsUpdater,
    isChanged,
    openProfileImageCropPage,
    openContactEditPage,
    buildFormData
}) {

    const navigate = useNavigate();
    const [, , updateProfileInfo] = useSetUserSession()
    const regex = new RegExp('^[0-9A-Za-z._-]{5,30}$');

    const onChangeBackgroundImage = (event) => {
        if (event.target.files && event.target.files[0]) {
            profileUpdater.setBackgroundImage(event.target.files[0])
        }
    }

    const onChangeProfileImage = (event) => {
        if (event.target.files && event.target.files[0]) {
            openProfileImageCropPage(URL.createObjectURL(event.target.files[0]))
        }
    }

    const goToDeleteAccountPage = () => navigate("/account/delete")

    const close = () => {
        if (!isChanged) {
            navigate(`/${link}`);
            return
        }

        Swal.fire({
            title: '저장이 되지 않았어요!',
            text: '저장을 하려면 취소 후 완료 버튼을 눌러주세요',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: '취소',
            cancelButtonColor: '#2D2D2D',
            confirmButtonText: '저장하지 않고 나가기',
            confirmButtonColor: '#2D2D2D'
        }).then(result => {
            if (result.isConfirmed) {
                return navigate(`/${link}`);
            }
        })
    }

    const update = async () => {
        //TODO 필수 입력 확인 필요
        if (!isChanged) {
            navigate(`/${link}`)
            return
        }

        try {
            const [profileFormData, imageFormData] = buildFormData()

            if (!regex.test(profileFormData.profileLink)) {
                await Swal.fire({
                    title: '프로필 링크가 유효하지 않아요!',
                    text: '5글자 이상 30글자 이하, 영어와 숫자 \'.\', \'_\', \'-\'만 사용할 수 있어요',
                    customClass: 'swal-alert',
                    allowOutsideClick: false,
                    confirmButtonText: '확인',
                    confirmButtonColor: '#2D2D2D'
                })

                return
            }

            const uploadImgRes = (await requestUploadProfileAndBackgroundImage(link, imageFormData)).data.result

            const mergedFormData = {
                ...profileFormData,
                profileImageUrl: uploadImgRes?.profileImageUrl,
                backgroundImageUrl: uploadImgRes?.backgroundImageUrl
            }

            const editProfileRes = await requestEditProfile(link, mergedFormData)

            if (editProfileRes.status === 200) {
                //TODO 프로필 링크 수정 구현이 되면 link 파라미터 수정 필요
                updateProfileInfo(profileUpdater.name, profileUpdater.profileLink)
                navigate(`/${profileUpdater.profileLink}`)
            }
        } catch (err) {
            if (err.response.status === 413) {
                await Swal.fire({
                    title: '사진의 용량이 너무 커요!',
                    text: '20MB 이하의 사진만 업로드할 수 있어요.',
                    customClass: 'swal-alert',
                    allowOutsideClick: false,
                    confirmButtonText: '확인',
                    confirmButtonColor: '#2D2D2D'
                })
            } else if (err.response.status === 400) {
                await Swal.fire({
                    title: '이미 사용 중인 프로필 링크입니다!',
                    text: '다른 프로필 링크를 입력해 주세요!',
                    customClass: 'swal-alert',
                    allowOutsideClick: false,
                    confirmButtonText: '확인',
                    confirmButtonColor: '#2D2D2D'
                })
            }
        }
    }


    //TODO 데이터 불러올때 페이지 어떻게 표시할건지 필요
    return (
        <div className="Layer profile-edit">
            <Header fixed={true}>
                <BackBtn position={"left"} onClick={close} />
                <CompleteBtn position={"right"} onClick={update} />
            </Header>
            <div className='Layer-inner'>
                <input className="profile-bg-input" id="backgroundImage" name="backgroundImage"
                    type="file"
                    accept="image/*" onChange={onChangeBackgroundImage} />
                <label htmlFor="backgroundImage">
                    <div className="profile-bg">
                        {profileUpdater.backgroundImageUrl ?
                            <img src={profileUpdater.backgroundImageUrl} alt=""
                                className='profile-bg-preview' /> :
                            <div className="empty-bg">
                            </div>}
                        <img className="profile-bg-icon" src="/assets/icons/add_photo.svg" alt="" />
                    </div>
                </label>

                <div className="contents-container">
                    <div className="profile-image-wrapper">
                        <input className="profile-image-input" id="profileImage" name="profileImage" type="file"
                            accept="image/*" onChange={onChangeProfileImage} /> {/* 이미지 크로퍼 복구 */}
                        <label htmlFor="profileImage">
                            <div className="profile-image">
                                {profileUpdater.profileImageUrl ?
                                    <img src={profileUpdater.profileImageUrl} alt=""
                                        className='profile-img-preview' /> :
                                    <div className="empty-pf">
                                    </div>}
                                <img className="profile-image-icon" src="/assets/icons/edit_pen.svg" alt="" />
                            </div>
                        </label>
                    </div>
                    <div className='title2-container'>
                        <h3 className='title'>프로필</h3>
                    </div>
                    <div className="inputs-container">
                        <InputBox title={"이름"} placeholder={"이름을 입력해주세요."} value={profileUpdater.name}
                            onChange={profileUpdater.setName} />
                        <InputBox title={"인사말"} placeholder={"인사말을 입력해주세요."} value={profileUpdater.description}
                            onChange={profileUpdater.setDescription} />
                        <InputBox title={"소속(직장/학교)"} placeholder={"직장/학교를 입력해주세요."} value={profileUpdater.job}
                            onChange={profileUpdater.setJob} />
                        <InputBox title={"주소(활동지역)"} placeholder={"활동지역을 입력해주세요."} value={profileUpdater.residence}
                            onChange={profileUpdater.setResidence} />
                        <InputBoxWithFixedText title={"프로필 링크"} value={profileUpdater.profileLink}
                            onChange={profileUpdater.setProfileLink} fixedText='sign-card.com/' />
                    </div>
                    <div className='title2-container'>
                        <div className='title'>연락처</div>
                    </div>

                    <div className="grid-wrapper">
                        <div className="icon-container">
                            <ContactCard contactType={ContactType.PHONE}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.KAKAOTALK}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.EMAIL}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                        </div>
                    </div>
                    <div className='title2-container'>
                        <h3 className='title'>소셜 링크</h3>
                    </div>
                    <div className="grid-wrapper">
                        <div className="icon-container">
                            <ContactCard contactType={ContactType.INSTAGRAM}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.FACEBOOK}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.TWITTER}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.WEB}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.NOTION}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                            <ContactCard contactType={ContactType.LINKEDIN}
                                isContactsNotEmpty={contactsUpdater.isContactsNotEmpty}
                                openContactEditPage={openContactEditPage} />
                        </div>
                    </div>
                    <div className="activation-container">
                        <Switch title={"링크 활성화"} isChecked={profileUpdater.linkValid}
                            onChange={profileUpdater.toggleLinkValid} />
                        <Switch title={"카드 활성화"} isChecked={profileUpdater.cardValid}
                            onChange={profileUpdater.toggleCardValid} />
                    </div>
                    <div className="primary-btn-container">
                        <div className='btn' onClick={goToDeleteAccountPage}>
                            계정 지우기
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ProfileEditPage;